/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Multiview_Min_Groups_WarningInputs */



/**
* | output |
* | --- |
* | "Select at least two event groups" |
*
* @param {Multiview_Min_Groups_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const multiview_min_groups_warning = /** @type {((inputs?: Multiview_Min_Groups_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Multiview_Min_Groups_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez au moins deux groupes d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie mindestens zwei Ereignisgruppen aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona almeno due gruppi di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите как минимум две группы мероприятий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione al menos dos grupos de eventos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择至少两个事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("少なくとも2つのイベントグループを選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कम से कम दो इवेंट समूहों का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione pelo menos dois grupos de eventos.")
	return /** @type {LocalizedString} */ ("Select at least two event groups")
});